import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import columns from "./columns";
import { formatAuth } from '@/utils/commonUtils'
import { AudienceGroupItem } from '@/components';

const { WizContainer, modelUtils } = framework_tool;
const { WizSpin, WizForm,WizCard } = component_tool;

class Whitelist extends WizContainer {
  componentName = "Whitelist";


  constructor(props) {
    super(props);
    this.state = {
      personIds:[]
    }
}
  getData = () => {

    this.doAction({
      path: "whitelist/authInfo",
      payload: {
        key: "whitelist@authInfo",
        apiParams: { bizType:49, bizId:1 },
      },
    });
  }

  _componentDidMount() {
    this.getData()
  }

   propsAndStateOnChange = {
    authInfo: this._authInfo.bind(this),
    save: this._save.bind(this),
    listPersonInfo: this._listPersonInfo.bind(this),
  };

  _listPersonInfo(nextProps, nextState) {
    const { listPersonInfo } = nextProps;
    if (listPersonInfo.success) {
      nextState['personIds'] = listPersonInfo.data
      return true;
    }
    wizNotice.error(listPersonInfo.msg)
    return false;
  }
  _authInfo(nextProps, nextState) {
    const { authInfo } = nextProps;
    if (authInfo.success) {
      
    let parm = formatAuth(authInfo.data)
    this.doAction({
      path: "whitelist/listPersonInfo",
      payload: {
        key: "whitelist@listPersonInfo",
        apiParams: {...parm,permType:1}
      }
    })
      return true;
    }
    wizNotice.error(authInfo.msg)
    return false;
  }

  _save(nextProps, nextState) {
    const { save } = nextProps;
    
    if (save.success) {
      wizNotice.success('保存成功')
    } else {
      wizNotice.error(save.msg)
      return false;
    }
  }

  // 提交
  onSubmit = values => {
    values.authCmd = formatAuth(values.authCmd)
    values.bizType = 49
    values.bizId = 1

    this.doAction({
      path: "whitelist/save",
      payload: {
        key: "whitelist@save",
        apiParams: values
      }
    })
  }
  _formOnchange(e,v){
    let parm = formatAuth(v)
    this.doAction({
      path: "whitelist/listPersonInfo",
      payload: {
        key: "whitelist@listPersonInfo",
        apiParams: {...parm,permType:1}
      }
    })
  }

  _render() {
    const { whitelistLoading, authInfo } = this.props
    const {personIds} = this.state
    const formProps = {
      ref: 'form',
      columns: columns(authInfo?.data || {},this._formOnchange.bind(this)),
      onSubmit: this.onSubmit,
      onReset: (f) => {
        let parm = formatAuth(authInfo?.data || {})
        this.doAction({
          path: "whitelist/listPersonInfo",
          payload: {
            key: "whitelist@listPersonInfo",
            apiParams: {...parm,permType:1}
          }
        })
      },
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizSpin spinning={whitelistLoading}>
        
        <WizCard title='白名单设置' icon='setting'>
        <WizForm {...formProps} />
        </WizCard>
        <WizCard title='白名单' icon='menu'>
              <AudienceGroupItem personIds={personIds||[]} orgIds={[]} positionCategoryIds={[]} positionIds = {[]} showMessage={true} /> 
        </WizCard>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { whitelist } = state;
  const authInfo = modelUtils.getModelEntity(whitelist,'whitelist@authInfo');
  const listPersonInfo = modelUtils.getModelEntity(whitelist,'whitelist@listPersonInfo');
  const save = modelUtils.getModelEntity(whitelist,'whitelist@save');
  const load = modelUtils.getLoadingState(state, "whitelist");

  return {
    authInfo,
    listPersonInfo,
    save,
    ...load,
  };
};

export default connect(mapStateToProps)(Whitelist);
